import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import usePrevious from 'lib/src/hooks/usePrevious';
import useForm from '@components/form/hooks/useForm';

import { updateAdminUserPassword } from '@actions/adminUsers';
import { getAdminUserPostSuccess } from '@selectors/adminUsers';
import { useHistory } from 'react-router-dom';

export default function useUpdateAdminPassword(userID: number): UpdateAdminPasswordReturn {
    const dispatch = useDispatch();
    const history = useHistory();

    const closeModal = useCallback(() => {
        history.replace(`/admins/${userID}`);
    }, [history, userID]);

    const [formState, handleChange, _, initForm] = useForm({ password: '', confirmPassword: '' });

    const handleSubmit = useCallback(() => {
        dispatch(updateAdminUserPassword(userID, formState));
    }, [dispatch, userID, formState]);

    const postSuccess = useSelector(getAdminUserPostSuccess);
    const prevPostSuccess = usePrevious(postSuccess);

    useEffect(() => {
        if (!prevPostSuccess && postSuccess) {
            closeModal();
        }
    }, [postSuccess, prevPostSuccess, closeModal]);

    return {
        closeModal,
        handleSubmit,
        formState,
        handleChange,
        initForm,
    };
}

interface FormState {
    password: string;
    confirmPassword: string;
}

interface UpdateAdminPasswordReturn {
    closeModal: () => void;
    handleSubmit: () => void;
    formState: FormState;
    handleChange: <T>(name: 'password' | 'confirmPassword', value: T) => void;
    initForm: () => void;
}
